import ProTextInput from "../../../../Components/Inputs/TextField";
import ProSelectInput from "../../../../Components/Inputs/SelectField"
import FormSectionWrapper from "../../../../Components/ProForms/FormSectionWrapper";
import DateField from "../../../../Components/Inputs/DateField";

const ProjectDetailsSection = ({
  defaultFormProps,
  formConfig,
  permissions,
  workTypeList,
  projectKickoff,
  communitySolarOptions,
  coLocatedProjectOptions,
}) => {
  const fieldPermission = key => permissions.fieldPerObj[formConfig[key].perKey];

  // Field configuration metadata
  const fields = [
    { key: "workId", type: "select", options: workTypeList },
    { key: "projectKickoff", type: "select", options: projectKickoff },
    { key: "actualConstructionStartDate", type: "date" },
    { key: "projectType", type: "text" },
    { key: "projectStatus", type: "text" },
    { key: "eiaId", type: "text" },
    { key: "dockets", type: "text" },
    { key: "batteryType", type: "text" },
    { key: "communitySolar", type: "select", options: communitySolarOptions },
    { key: "coLocatedProject", type: "select", options: coLocatedProjectOptions },
    { key: "projectCapacityMW", type: "text" },
    { key: "projectClassification", type: "text" },
    { key: "powerPurchaser", type: "text" },
    { key: "powerPurchaseAgreementCapacityMW", type: "text" },
    { key: "powerPurchaseAgreementYears", type: "text" },
    { key: "supplier", type: "text" },
    { key: "unitType", type: "text" },
    { key: "unitSupplied", type: "text" },
    { key: "firstPowerDate", type: "date" },
    { key: "firstPowerYear", type: "text" },
    { key: "projectLastUpdatedDate", type: "date" },
  ];

  const renderField = ({ key, type, options }) => {
    const config = formConfig[key];
    const permission = fieldPermission(key);

    const commonProps = {
      key,
      ...defaultFormProps,
      ...config,
      permission,
    };

    switch (type) {
      case "select":
        return <ProSelectInput {...commonProps} options={options} />;
      case "date":
        return <DateField {...commonProps} />;
      default:
        return <ProTextInput {...commonProps} />;
    }
  };

  return (
    permissions.canView && (
      <FormSectionWrapper collapsible title="Project Details">
        {fields.map(renderField)}
      </FormSectionWrapper>
    )
  );
};

export default ProjectDetailsSection;
